import * as React from 'react';

/**
 * @beta
 */
export type As<Props = any> = React.ElementType<Props>;
/**
 * @beta
 */
export type PropsWithAs<Props = {}, Type extends As = As> = Props &
  Omit<React.ComponentProps<Type>, 'as' | keyof Props> & {
    as?: Type;
  };
/**
 * @beta
 */
export type ComponentWithAs<Props, DefaultType extends As> = {
  <Type extends As>(
    props: PropsWithAs<Props, Type> & { as: Type }
  ): JSX.Element;
  (props: PropsWithAs<Props, DefaultType>): JSX.Element;
  displayName?: string;
};

export type ComponentWithAs1<
  Props,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  DefaultType extends As
> = React.Component<Props>;

/**
 * @beta
 */
export function forwardRefWithAs<Props, DefaultType extends As>(
  component: React.ForwardRefRenderFunction<any, any>
) {
  return (React.forwardRef(component) as unknown) as ComponentWithAs<
    Props,
    DefaultType
  >;
}
